import React, { useRef } from "react";

import {
  Flex,
  Icon,
  IconButton,
  useBreakpointValue,
  Text,
  Box,
  useDisclosure,
} from "@chakra-ui/react";
import { RiMenuLine } from "react-icons/ri";
import { useSidebarDrawer } from "../../context/SidebarDrawerContext";

import { NotificationsNav } from "./NotificationsNav";
import { Profile } from "./Profile";
import { SearchBox } from "./SearchBox";
import { Logo } from "./Logo";

export function Header() {
  const { onOpen } = useSidebarDrawer();

  const isWideVersion = useBreakpointValue({
    base: false,
    lg: true,
  });

  const isMdVersion = useBreakpointValue({
    base: false,
    md: true,
  });

  return (
    <Flex
      as="header"
      w="100%"
      maxWidth="100%"
      h="20"
      align="center"
      bg="bg"
      pt="65px"
      mb="75px"
      px={isMdVersion ? "10" : "3"}
    >
      {!isWideVersion && (
        <IconButton
          aria-label="Open navigation"
          icon={<Icon as={RiMenuLine} />}
          fontSize="30"
          variant="unstyled"
          color="white"
          onClick={onOpen}
          mr="2"
        ></IconButton>
      )}

      <Logo />

      {isWideVersion && <SearchBox />}

      <Flex align="center" ml="auto">
        <NotificationsNav />

        <Profile
          //@ts-ignore
          showProfileData={isWideVersion}
        />
      </Flex>
    </Flex>
  );
}
